import { z } from 'zod';

export const uuidSchema = z.uuid();

export const currencySchema = z.string().regex(/^[A-Z]{3}$/, 'ISO 4217 currency code expected');

/** Integer minor units only; never accepts fractional numbers (spec §2). */
export const amountMinorSchema = z.number().int().refine(Number.isSafeInteger, {
  message: 'amount_minor must be a safe integer',
});

export const moneySchema = z.object({
  amount_minor: amountMinorSchema,
  currency: currencySchema,
});
export type MoneyDto = z.infer<typeof moneySchema>;

export const quantitySchema = z.object({
  quantity_scaled: z.number().int().refine(Number.isSafeInteger),
  quantity_scale: z.union([
    z.literal(1),
    z.literal(10),
    z.literal(100),
    z.literal(1000),
    z.literal(10000),
  ]),
});

export const isoTimestampSchema = z.iso.datetime({ offset: false, precision: 3 });

export const timeZoneSchema = z.string().min(1).max(64);

export const localeSchema = z.enum(['en', 'id']);
export type Locale = z.infer<typeof localeSchema>;

export const cursorPageQuerySchema = z.object({
  cursor: z.string().max(512).optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});

export function cursorPageSchema<T extends z.ZodType>(item: T) {
  return z.object({
    items: z.array(item),
    next_cursor: z.string().nullable(),
  });
}
